import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  // Verificar se usuário está logado ao iniciar
  useEffect(() => {
    let isMounted = true;

    const initAuth = async () => {
      console.log('🔐 AuthContext: Inicializando autenticação...');
      const storedToken = localStorage.getItem('token');
      const storedUser = localStorage.getItem('user');

      console.log('🔐 AuthContext: Token encontrado:', !!storedToken);
      console.log('🔐 AuthContext: User encontrado:', !!storedUser);

      if (storedToken && storedUser) {
        try {
          console.log('🔐 AuthContext: Verificando token com API...');
          const response = await authService.getCurrentUser();

          if (isMounted) {
            if (response && response.user) {
              setUser(response.user);
              setToken(storedToken);
              console.log('🔐 AuthContext: ✅ Usuário autenticado:', response.user?.name);
            } else {
              console.warn('🔐 AuthContext: Resposta da API sem usuário');
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              setToken(null);
              setUser(null);
            }
          }
        } catch (error) {
          console.error('🔐 AuthContext: Erro na API:', error);
          if (isMounted) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setToken(null);
            setUser(null);
          }
        }
      } else {
        console.log('🔐 AuthContext: Nenhum token encontrado, usuário não autenticado');
      }

      if (isMounted) {
        console.log('🔐 AuthContext: Definindo loading como false');
        setLoading(false);
      }
    };

    // Pequeno delay para evitar problemas de inicialização
    const timeout = setTimeout(() => {
      if (isMounted) {
        initAuth();
      }
    }, 100);

    return () => {
      isMounted = false;
      clearTimeout(timeout);
    };
  }, []);

  // Função de login
  const login = async (credentials) => {
    try {
      console.log('🔐 AuthContext: Tentando login com:', credentials.email);
      const response = await authService.login(credentials);

      localStorage.setItem('token', response.token);
      localStorage.setItem('user', JSON.stringify(response.user));

      setToken(response.token);
      setUser(response.user);
      console.log('🔐 AuthContext: Estado atualizado:', response.user?.name);

      return { success: true };
    } catch (error) {
      console.error('🔐 AuthContext: Erro no login:', error);
      return {
        success: false,
        error: error.message || 'Erro ao fazer login'
      };
    }
  };

  // Função de logout
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    isAuthenticated: !!token
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
